import { createContext, useContext } from "react";
import { IOfferContext } from "./types";

export const OfferContext = createContext<IOfferContext | null>(null);

export const useOfferContext = () => {
  const context = useContext(OfferContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
